// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__OtluM","innerContainer":"style_innerContainer__4uWLW","header":"style_header__Brglj","infoContainer":"style_infoContainer__tFjbl"};